import { useEffect, useRef } from 'react';

/**
 * React hook that stores a value from the previous render.
 * @template T
 * @param {T} value
 * @returns {T}
 */
const usePrevious = (value: any) => {
  const ref = useRef<any>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
